import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/front.vue
var s = {
	name: "DtIconFront",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["fill"], u = ["fill"], d = ["id"], f = ["id"];
function p(e, t, n, s, p, m) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([m.iconSizeClass, "d-icon d-icon--front"]),
		"data-qa": m.dataQA,
		"aria-hidden": m.ariaHidden,
		role: "img",
		"data-name": "Front",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [
		t[2] || (t[2] = i("path", {
			"fill-rule": "evenodd",
			"clip-rule": "evenodd",
			d: "M5.223 5.45a3.302 3.302 0 0 1 3.302-3.302h10.59v4.7a1.65 1.65 0 0 1-1.65 1.651h-4.33a1.588 1.588 0 0 0-1.561 1.566v10.279c0 .912-.74 1.65-1.651 1.65h-4.7V5.452z",
			fill: "#001B38"
		}, null, -1)),
		i("path", {
			d: "M8.914 10.127a4.287 4.287 0 1 0 8.574 0 4.287 4.287 0 0 0-8.574 0z",
			fill: `url(#${e.uniqueID}a)`
		}, null, 8, l),
		i("path", {
			opacity: ".5",
			d: "M8.914 10.127a4.287 4.287 0 1 0 8.574 0 4.287 4.287 0 0 0-8.574 0z",
			fill: `url(#${e.uniqueID}b)`
		}, null, 8, u),
		i("defs", null, [i("linearGradient", {
			id: `${e.uniqueID}a`,
			x1: "10.182",
			y1: "6.913",
			x2: "16.629",
			y2: "13.404",
			gradientUnits: "userSpaceOnUse"
		}, [...t[0] || (t[0] = [i("stop", {
			"stop-color": "#FF0057",
			"stop-opacity": ".16"
		}, null, -1), i("stop", {
			offset: ".861",
			"stop-color": "#FF0057"
		}, null, -1)])], 8, d), i("linearGradient", {
			id: `${e.uniqueID}b`,
			x1: "10.182",
			y1: "6.913",
			x2: "16.629",
			y2: "13.404",
			gradientUnits: "userSpaceOnUse"
		}, [...t[1] || (t[1] = [i("stop", {
			"stop-color": "#FF0057",
			"stop-opacity": ".16"
		}, null, -1), i("stop", {
			offset: ".861",
			"stop-color": "#FF0057"
		}, null, -1)])], 8, f)])
	], 10, c);
}
var m = /* @__PURE__ */ n(s, [["render", p]]);
//#endregion
export { m as default };

//# sourceMappingURL=front.js.map